import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { jsonParse } from 'src/app/helper/class/utilityHelper';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthApiService {

  constructor(private http: HttpClient) { }

  otpSend(num: any, type = 'LOGIN') {
    return lastValueFrom(this.http.get(`sendOTP/${num}/${type}`));
  }
  resendOtp(num: any, type = 'LOGIN') {
    return lastValueFrom(this.http.get(`resendOTP/${num}/${type}`));
  }
  login(data: any) {
    return lastValueFrom(this.http.post(`Auth/login`, data));
  }
  getRolePermission(data: any) {
    return lastValueFrom(this.http.get(`getAllPermission/${data}`));
  }
  loginOTP(data: any) {
    return lastValueFrom(this.http.post(`Auth/loginVerifyOtp`, data));
  }
  changePassword(data: any) {
    return lastValueFrom(this.http.post(`Auth/changePassword`, data));
  }

  getUserPermission(id: any) {
    return lastValueFrom(this.http.get(`role/getPermissionByUser/${id}`));
  }
  saveRolePermission(data: any, id: string) {
    return lastValueFrom(this.http.post(`role/updatePermission/${id}`, data));
  }
  getRolePermissionByRole(id: any, isFull = false) {
    if (isFull) {
      return lastValueFrom(this.http.get(`role/getPermissionFull/${id}`));
    } else {
      return lastValueFrom(this.http.get(`role/getPermission/${id}`));
    }
  }
  getSetting() {
    return lastValueFrom(this.http.get(`settings/getSetting`));
  }

  saveSetting(data: any) {
    return lastValueFrom(this.http.post(`settings/save`, data));
  }
  licencePass(data: any) {
    return lastValueFrom(this.http.post(`renewLicence`, data));
  }
}